import "../../styles/custom_search_sort_header.css";
import { useState, useEffect } from "react";
import DatePicker from "../datePicker";

const processes = [
  { value: "Normal", label: "Normal", searchValue: "Normal" },
  { value: "Urgent", label: "Urgency", searchValue: "Urgency" },
  { value: "Fast Track", label: "Fast Track", searchValue: "Fast Track" },
  { value: "Vacation", label: "Vacation", searchValue: "Vacation" },
];

const CustomSearchSortHeader = ({
  onSearch,
  frequentData,
  caseProcess = "all",
  filingType = "all",
  isSearchOnly = false,
  isSearchAndDateOnly = false,
  caseTypeId = "",
  caseCategoryId = "",
  excludeCategoryIds = [],
  excludeProcessTypes = [],
  role = "",
}) => {
  const [search, setSearch] = useState({
    caseTitle: "",
    caseNumber: "",
    fromDate: "",
    toDate: "",
    filingtype: filingType,
    caseprocess: caseProcess,
    caseTypeId: caseTypeId,
    caseCategoryId: caseCategoryId,
  });

  const onSearchChange = (e) => {
    setSearch({ ...search, [e.target.name]: e.target.value });
  };

  const onSearchInputChange = (e) => {
    const value = e.target.value;

    if (!value.trim() || value.trim() === "") {
      onSearch({
        ...search,
        caseTitle: "",
        caseNumber: "",
      });
    }

    const isIdOrRef = value.includes("ID/") || value.includes("REF");

    if (isIdOrRef) {
      setSearch({
        ...search,
        caseNumber: value,
        caseTitle: "",
      });
    } else {
      setSearch({
        ...search,
        caseTitle: value,
        caseNumber: "",
      });
    }
  };

  // const onCaseProcess = (value) => {
  //   if (search.caseprocess === value) {
  //     setSearch({ ...search, caseprocess: "all" });
  //   } else {
  //     setSearch({ ...search, caseprocess: value });
  //   }
  // };

  const onFilingType = (e) => {
    setSearch({ ...search, filingtype: e.target.value });
  };

  useEffect(() => {
    onSearch(search);
  }, [
    search.fromDate,
    search.toDate,
    search.filingtype,
    search.caseprocess,
    search.caseTypeId,
    search.caseCategoryId,
  ]);

  return (
    <div className="case-header">
      <div className="search-inputs-section">
        {/* input */}
        <div className="search-wrapper">
          <div className="search_wrapper">
            <div className="search_icon">
              <svg
                width={16}
                height={16}
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.33301 13.332C10.6467 13.332 13.333 10.6457 13.333 7.33203C13.333 4.01832 10.6467 1.33203 7.33301 1.33203C4.0193 1.33203 1.33301 4.01832 1.33301 7.33203C1.33301 10.6457 4.0193 13.332 7.33301 13.332Z"
                  stroke="#292D32"
                  strokeOpacity="0.5"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M12.6196 13.7939C12.973 14.8605 13.7796 14.9672 14.3996 14.0339C14.9663 13.1805 14.593 12.4805 13.5663 12.4805C12.8063 12.4739 12.3796 13.0672 12.6196 13.7939Z"
                  stroke="#292D32"
                  strokeOpacity="0.5"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <input
              type="text"
              name="caseTitle"
              value={search.caseTitle || search.caseNumber}
              onChange={onSearchInputChange}
              placeholder={
                role === "cfo"
                  ? "Search with suit number"
                  : "Search with case title or suit number"
              }
            />
            <button className="search_btn" onClick={() => onSearch(search)}>
              Search
            </button>
          </div>
        </div>
        {(isSearchAndDateOnly || !isSearchOnly) && (
          <div className="search-date-wrapper">
            <DatePicker
              selectedDate={search.fromDate ? new Date(search.fromDate) : null}
              onDateChange={(date) =>
                setSearch({
                  ...search,
                  fromDate: date ? date.toLocaleDateString("en-CA") : "",
                })
              }
              placeholder="Start Date"
            />
            <DatePicker
              selectedDate={search.toDate ? new Date(search.toDate) : null}
              onDateChange={(date) => {
                setSearch({
                  ...search,
                  toDate: date ? date.toLocaleDateString("en-CA") : "",
                });
              }}
              placeholder="End Date"
            />
          </div>
        )}
      </div>

      {!isSearchOnly && !isSearchAndDateOnly && (
        <div className="sort_container">
          <div className="select_wrapper">
            <select
              name="caseTypeId"
              value={search.caseTypeId || ""}
              onChange={onSearchChange}
              className="sort_button"
            >
              <option value="">Select Case Type</option>
              {frequentData?.casetype?.map((opt) => (
                <option key={opt.id} value={opt.id}>
                  {opt.caseType1}
                </option>
              ))}
            </select>
            <div className="select_icon">
              <svg
                width="8"
                height="8"
                viewBox="0 0 8 8"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M3.99952 5.60021C3.76619 5.60021 3.53285 5.51021 3.35618 5.33354L1.18285 3.16021C1.08618 3.06354 1.08618 2.90354 1.18285 2.80688C1.27952 2.71021 1.43952 2.71021 1.53618 2.80688L3.70952 4.98021C3.86952 5.14021 4.12952 5.14021 4.28952 4.98021L6.46285 2.80688C6.55952 2.71021 6.71952 2.71021 6.81618 2.80688C6.91285 2.90354 6.91285 3.06354 6.81618 3.16021L4.64285 5.33354C4.46619 5.51021 4.23285 5.60021 3.99952 5.60021Z"
                  fill="#282828"
                />
              </svg>
            </div>
          </div>
          <div className="select_wrapper">
            <select
              name="caseCategoryId"
              value={search.caseCategoryId || ""}
              onChange={onSearchChange}
              className="sort_button"
            >
              <option value="">Select Classification</option>
              {frequentData?.casecategories
                ?.filter((c) => c.caseTypeId == search.caseTypeId)
                ?.filter((c) => !excludeCategoryIds.includes(c.id))
                .map((opt) => (
                  <option key={opt.id} value={opt.id}>
                    {opt.categoryTitle}
                  </option>
                ))}
            </select>

            <div className="select_icon">
              <svg
                width="8"
                height="8"
                viewBox="0 0 8 8"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M3.99952 5.60021C3.76619 5.60021 3.53285 5.51021 3.35618 5.33354L1.18285 3.16021C1.08618 3.06354 1.08618 2.90354 1.18285 2.80688C1.27952 2.71021 1.43952 2.71021 1.53618 2.80688L3.70952 4.98021C3.86952 5.14021 4.12952 5.14021 4.28952 4.98021L6.46285 2.80688C6.55952 2.71021 6.71952 2.71021 6.81618 2.80688C6.91285 2.90354 6.91285 3.06354 6.81618 3.16021L4.64285 5.33354C4.46619 5.51021 4.23285 5.60021 3.99952 5.60021Z"
                  fill="#282828"
                />
              </svg>
            </div>
          </div>
          <div className="select_wrapper">
            <select
              name="filingtype"
              value={search.filingtype || ""}
              onChange={onFilingType}
              className="sort_button"
            >
              <option value="all">Sort</option>

              <option value="litigation">Litigation</option>

              <option value="adr">ADR</option>
            </select>
            <div className="select_icon">
              <svg
                width="8"
                height="8"
                viewBox="0 0 8 8"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M3.99952 5.60021C3.76619 5.60021 3.53285 5.51021 3.35618 5.33354L1.18285 3.16021C1.08618 3.06354 1.08618 2.90354 1.18285 2.80688C1.27952 2.71021 1.43952 2.71021 1.53618 2.80688L3.70952 4.98021C3.86952 5.14021 4.12952 5.14021 4.28952 4.98021L6.46285 2.80688C6.55952 2.71021 6.71952 2.71021 6.81618 2.80688C6.91285 2.90354 6.91285 3.06354 6.81618 3.16021L4.64285 5.33354C4.46619 5.51021 4.23285 5.60021 3.99952 5.60021Z"
                  fill="#282828"
                />
              </svg>
            </div>
          </div>
          {/* {processes
            .filter(
              (process) =>
                caseprocess === "all" || caseprocess === process.value
            )
            .map((process) => (
              <button
                key={process.value}
                className={`sort_button ${
                  search.caseprocess === process.searchValue ? "active" : ""
                }`}
                onClick={() => onCaseProcess(process.searchValue)}
              >
                {process.label}
              </button>
            ))} */}

          <div className="select_wrapper">
            <select
              name="caseprocess"
              value={search.caseprocess}
              onChange={onSearchChange}
              className="sort_button"
            >
              <option value="all">Mode of process</option>
              {processes
                .filter(
                  (process) => !excludeProcessTypes.includes(process.value),
                )
                .map((process) => (
                  <option key={process.value} value={process.searchValue}>
                    {process.label}
                  </option>
                ))}
            </select>
            <div className="select_icon">
              <svg
                width="8"
                height="8"
                viewBox="0 0 8 8"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M3.99952 5.60021C3.76619 5.60021 3.53285 5.51021 3.35618 5.33354L1.18285 3.16021C1.08618 3.06354 1.08618 2.90354 1.18285 2.80688C1.27952 2.71021 1.43952 2.71021 1.53618 2.80688L3.70952 4.98021C3.86952 5.14021 4.12952 5.14021 4.28952 4.98021L6.46285 2.80688C6.55952 2.71021 6.71952 2.71021 6.81618 2.80688C6.91285 2.90354 6.91285 3.06354 6.81618 3.16021L4.64285 5.33354C4.46619 5.51021 4.23285 5.60021 3.99952 5.60021Z"
                  fill="#282828"
                />
              </svg>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CustomSearchSortHeader;
